import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { IColumnDefinition } from '@common/models/column-definition';
import { IResizedColumn, ITable } from '@common/models/table';
import { EntityKey } from '@pma-entity/pma-entity-types';
import { ITableResponse } from "@feature/_app_modules/shared/table/table.types";

@Injectable()
export class TableHttpService {

  private readonly apiBaseUrl: string;

  constructor(
    private readonly http: HttpClient,
    private readonly urlBuilder: UrlBuilderService) {
    this.apiBaseUrl = urlBuilder.getUrl('table');
  }

  getTable(entityName: string, key: EntityKey | undefined, widgetId?: number): Observable<ITable> {
    const url = `${this.apiBaseUrl}/data`;
    return this.http.post<ITableResponse>(url, { EntityViewName: entityName, OwnerEntityKey: key, WidgetInstanceId: widgetId }).pipe(map(x=> x.Table));
  }

  getAvailableColumns(entityName: string, widgetId?: number): Observable<IColumnDefinition[]> {
    const url = `${this.apiBaseUrl}/availablecolumns`;
    return this.http.post<IColumnDefinition[]>(url, {EntityTypeName: entityName, WidgetInstanceId: widgetId})
  }

  getAllColumns(entityName: string): Observable<IColumnDefinition[]>{
    const url = `${this.apiBaseUrl}/allcolumns`;
    return this.http.post<IColumnDefinition[]>(url, {EntityTypeName: entityName})
  }

  setSelectedColumns(entityName: string, selectedColumns: IColumnDefinition[], widgetId?: number): Observable<boolean> {
    const url = `${this.apiBaseUrl}/updatecolumns`;
    const body = { EntityTypeName: entityName, SelectedColumns: selectedColumns, WidgetInstanceId: widgetId };
    return this.http.put(url, body).pipe(map(() => true));
  }

  reorderColumns(entityName: string, selectedColumns: string[], widgetId?: number): Observable<boolean> {
    const url = `${this.apiBaseUrl}/reordercolumns`;
    const body = { EntityTypeName: entityName, SelectedColumns: selectedColumns, WidgetInstanceId: widgetId }
    return this.http.put(url, body).pipe(map(() => true));
  }

  resizeColumn(entityName: string, resizedColumn: IResizedColumn, widgetId?: number): Observable<boolean> {
    const url = `${this.apiBaseUrl}/resizecolumn`;
    const body = { EntityTypeName: entityName, ResizedColumn: resizedColumn, WidgetInstanceId: widgetId }
    return this.http.put(url, body).pipe(map(() => true));
  }

  resetColumnsToDefault(entityName: string, widgetId?: number): Observable<boolean> {
    const url = `${this.apiBaseUrl}/setdefaultcolumns`;
    return this.http.put(url, {EntityTypeName: entityName, WidgetInstanceId: widgetId}).pipe(map(() => true));
  }
}
